/*
 * seasons reducer
 */
import { SEASONS_SET, SEASONS_MERGE, SEASON_SET } from './constants';
import { RESET_STATE } from '../auth/constants';

type State = {
    [string]: Object
};

type Action = {
    +type: string,
    +payload: Object
};

const initialState = {};

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case SEASONS_SET:
            return {
                ...action.payload
            };
        case SEASONS_MERGE:
            return {
                ...state,
                ...action.payload
            };
        case SEASON_SET:
            return {
                ...state,
                [action.payload.id]: action.payload
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
